import { Injectable } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivate,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { AuthService } from '@mangosoft/mango-login';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class LoginGuardGuard implements CanActivate {
	constructor(private authService: AuthService, private router: Router) {}
	canActivate(
		route: ActivatedRouteSnapshot,
		state: RouterStateSnapshot
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const token = this.authService.getToken() ? false : true;
		if (!token) {
			this.router.navigate(['/system-modules']);
		}
		return token;
	}
}
